// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { FiltersDto , FiltersDtoFormGroup } from '../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/FiltersDto';

export class AppUserFiltersDto extends FiltersDto {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
}

export interface AppUserFiltersDtoFormGroup extends FiltersDtoFormGroup {
  firstName?: any;
  lastName?: any;
  email?: any;
}
